import { NotifyContext, UserContext } from "context";
import React, { useContext, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import dateUtils from "utils/dateUtils";
import CrashPointsTable from "./CrashPointsTable";

const initDate = (date) => { 
  if(date){
    const start = new Date( dateUtils.formatDate(new Date(date)) + " 00:00:00" );
    const end = null;
    return {start, end}
  }else{
    const start = new Date( dateUtils.formatDate(new Date()) + " 00:00:00" );
    const end = new Date( dateUtils.formatDate(new Date()) + " 00:00:00" );
    return {start, end}
  }
}

const initFilter = (data) => { 
  if(data){
    const {id, car} = data;
    const readyFilter = {};
    if(car) {readyFilter.filCarNumber = car}
    if(id) {readyFilter.departureId = id}
    return readyFilter;
  }else{
    return {}
  }

 }

const ViolationPage = ({ ...props }) => {
  const { intl, crashState, setCrashState } = props;
  const { pushNotify } = useContext(NotifyContext);
  const { logout } = useContext(UserContext);
  const [initRange, setInitRange] = useState(initDate(crashState?.dateOrder))
  const [filter, setFilter] = useState(initFilter(crashState))

  useEffect(() => {
    return () => {
      setCrashState({})
    }
  }, [setCrashState])

  return (
    <div className="violations-page">
      <CrashPointsTable pushNotify={pushNotify} logout={logout} intl={intl} initDate={initRange} initFilter={filter} />
    </div>
  );
};

export default injectIntl(ViolationPage);
